var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/* tslint:disable:jsx-no-multiline-js */
import classnames from 'classnames';
import React from 'react';
class ButtonChlid extends React.Component {
    constructor(props) {
        super(props);
        this.buttonClick = (e) => {
            e.nativeEvent.stopImmediatePropagation();
            this.props.onClick && this.props.onClick();
        };
    }
    render() {
        const _a = this.props, { prefixCls, className, children, thumb, nodeIndex, direction, size, childNodeLength, buttonMoveCls, btnStatus, btnMoveCls } = _a, restProps = __rest(_a, ["prefixCls", "className", "children", "thumb", "nodeIndex", "direction", "size", "childNodeLength", "buttonMoveCls", "btnStatus", "btnMoveCls"]);
        const index = nodeIndex + 1;
        const moveIndex = Math.abs(index - Number(childNodeLength)) + 1;
        const wrapCls = classnames(className, `animated`, `${btnMoveCls}`, `${prefixCls}-child`, `${prefixCls}-child-${index}`, `${buttonMoveCls}-${direction === "left" ? index : moveIndex}`, `${prefixCls}-child-move`, {});
        const left = `${index * Number(size) + index * Number(size) * 0.3}px`;
        const position = direction === "right" ? left : `-${left}`;
        return (<div {...restProps} className={wrapCls} style={{
            left: position,
            display: btnMoveCls ? 'block' : 'none',
            animationDelay: `${index * 50}ms`,
        }} onClick={this.buttonClick}>
        <div className={`${prefixCls}-child-wrapper`} style={{ width: `${size}px`, height: `${size}px` }}>
          {children}
        </div>
      </div>);
    }
}
ButtonChlid.defaultProps = {
    prefixCls: 'bs-float-button',
};
export default ButtonChlid;



// WEBPACK FOOTER //
// ./components/float-button/ButtonChild.tsx